import { useQuery } from '@tanstack/react-query';
import apiClient from '../api-client';

export type FixtureScoreSnapshot = {
  externalId: string;
  status: 'scheduled' | 'live' | 'finished' | 'postponed' | 'cancelled';
  clock: string;
  quarter: number | null;
  homeScore: number | null;
  awayScore: number | null;
  homeTeam: { id: string; name: string } | null;
  awayTeam: { id: string; name: string } | null;
  scheduledDate: string;
};

type GetFixtureScoresBatchResponse = {
  success: boolean;
  fixtures: Record<string, FixtureScoreSnapshot | null>;
};

export const getFixtureScoresBatch = async (
  contestIds: string[]
): Promise<GetFixtureScoresBatchResponse> => {
  const ids = contestIds.filter(Boolean).join(',');
  return apiClient.get<GetFixtureScoresBatchResponse>('/api/squares/fixture-scores', {
    params: { ids },
  });
};

export const useGetFixtureScoresBatchQuery = (contestIds: string[]) => {
  const stableIds = [...new Set(contestIds.filter(Boolean))].sort();

  return useQuery<GetFixtureScoresBatchResponse>({
    queryKey: ['squares', 'fixture-scores-batch', stableIds],
    queryFn: () => getFixtureScoresBatch(stableIds),
    enabled: stableIds.length > 0,
    refetchInterval: query => {
      const data = query.state.data as GetFixtureScoresBatchResponse | undefined;
      const fixtures = data?.fixtures ? Object.values(data.fixtures) : [];
      const anyLive = fixtures.some(f => f?.status === 'live');
      return anyLive ? 10_000 : false;
    },
  });
};
